import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class RoleService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get(environment.Localurl + "role");
  }

  insert(data) {
    return this.http.post(environment.Localurl + "role", data);
  }

  delete(id) {
    return this.http.delete(environment.Localurl + "role" + "/" + id);
  }

  getOne(id) {
    return this.http.get(environment.Localurl + "role" + "/" + id);
  }
  update(id, data) {
    return this.http.put(environment.Localurl + "role" + "/" + id, data);
  }
}
